import { I18n } from "@assets/strings";
import React, { useMemo } from "react";
import { useHistory } from "@core/routing/useHistory";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { DiscussionTab, discussionTabs, Path } from "@core/routing/path";
// import { useServices } from "../../../core/servicesContext";
import { Redirect } from "@core/routing/redirect";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { useGroup } from "@domain/group/hooks";
import { AppAuthIncentive } from "@ui/components/appAuthIncentive";
import { stack } from "@ui/components/layout";
import { ScrollBehavior } from "@ui/components/navigation/scrollToTop";
import { Page } from "@ui/components/page";
import { TabSelector } from "@ui/components/tabSelector";
import { mobile } from "@ui/styles/utils";
import { NotFoundPage } from "@ui/pages/notFoundPage";
import { GroupActivity } from "./groupActivity";
import { GroupCommunity } from "./groupCommunity";
import { GroupHeader } from "./groupHeader";
import { GroupAccess } from "./groupeAccess";

interface GroupPageProps extends React.HTMLAttributes<HTMLDivElement> {
	groupId?: string;
	groupSlug?: string;
	tab?: DiscussionTab;
	workspaceId?: string;
	action?:
		| "track_USER_INVITED_TO_SHAREROOM"
		| "track_USER_ACCEPTED_TO_SHAREROOM"
		| "track_USER_REMOVED_FROM_SHAREROOM"
		| "track_USER_INVITED_TO_GROUP"
		| "track_USER_ACCEPTED_TO_GROUP"
		| "track_USER_REMOVED_FROM_GROUP";
}
export const GroupPage: React.FC<GroupPageProps> = ({
	groupId,
	groupSlug,
	tab = "activity",
	workspaceId,
	action,
	...htmlProps
}) => {
	const { result: group, loading, error } = useGroup(groupId ?? "", groupSlug);

	const history = useHistory();
	// const location = useLocation();

	// const { groupService, trackingService } = useServices();
	const currentProfile = useCurrentProfile();

	const displayedTabs = useMemo(() => {
		if (group?.userRole === "ADMINISTRATOR") {
			return discussionTabs;
		}
		const hideCommunity = !group?.memberCounts.MEMBER;
		return discussionTabs.filter((tab) => tab !== "community" || !hideCommunity);
	}, [group]);

	if (error?.code === 404) {
		return <NotFoundPage message={I18n.t("404.group")} />; // TODO Handle shareroom
	}

	if (group?.type === "SHAREROOM") {
		return <Redirect to={Path.Shareroom({ id: groupId, slug: groupSlug })} />;
	}

	// useEffect(() => {
	// 	if (action === "track_USER_INVITED_TO_SHAREROOM") {
	// 		trackingService.track("trackEmail - track_USER_INVITED_TO_SHAREROOM");
	// 	}
	// 	if (action === "track_USER_ACCEPTED_TO_SHAREROOM") {
	// 		trackingService.track("trackEmail - track_USER_ACCEPTED_TO_SHAREROOM");
	// 	}
	// 	if (action === "track_USER_REMOVED_FROM_SHAREROOM") {
	// 		trackingService.track("trackEmail - track_USER_REMOVED_FROM_SHAREROOM");
	// 	}

	// 	if (action === "track_USER_INVITED_TO_GROUP") {
	// 		trackingService.track("trackEmail - track_USER_INVITED_TO_GROUP");
	// 	}
	// 	if (action === "track_USER_ACCEPTED_TO_GROUP") {
	// 		trackingService.track("trackEmail - track_USER_ACCEPTED_TO_GROUP");
	// 	}
	// 	if (action === "track_USER_REMOVED_FROM_GROUP") {
	// 		trackingService.track("trackEmail - track_USER_REMOVED_FROM_GROUP");
	// 	}
	// }, []);

	return !group ? (
		loading ? (
			<ClipLoader />
		) : null
	) : (
		<Container {...htmlProps}>
			{/* <HelmetInfos
				title={I18n.t(`seo.group.${group.type}.title`, { name: group.name })}
				description={[group.description, group.categories.map((cat) => I18n.t(`category.${cat}`)).join(", ")]
					.filter(Boolean)
					.join(" - ")}
			/> */}
			<GroupHeader group={group} />
			{group.userRole && group.status !== "PENDING_GUEST_ACCEPTANCE" && group.status !== "PENDING_HOST_ACCEPTANCE" ? (
				<>
					<TabSelector
						items={displayedTabs}
						selectedIndex={displayedTabs.indexOf(tab)}
						onItemSelected={(index) => {
							history.push(
								Path.Discussion(group, index === 0 ? undefined : displayedTabs[index]),
								ScrollBehavior.NoScroll
							);
						}}
						itemRenderer={(item) => I18n.t(`group.tab.${item}`)}
					/>

					{tab === "activity" ? <GroupActivity group={group} /> : <GroupCommunity group={group} />}
				</>
			) : (
				<GroupAccess group={group} />
			)}
			{!currentProfile && group && (
				<AppAuthIncentive message={I18n.t(`group.${group?.type}.auth.incentive`, { name: group?.name })} />
			)}
		</Container>
	);
};

const Container = styled(Page)`
	${stack(45, "flex-start", "stretch")};
	@media ${mobile} {
		${stack(30, "flex-start", "stretch")};
	}
`;
